import React from "react";
import ReactApexChart from "react-apexcharts";

const UserSubscriptionStatistic = ({ states }) => {
  const chartData = states?.first_chart_data || {};
  const labels = Object.keys(chartData);
  const paid_users = labels.map((label) => chartData[label].paid_users);
  const free_users = labels.map((label) => chartData[label].free_users);

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    colors: ["#3B82F6", "#FACC15"], // blue for paid, yellow for free
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40%",
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    legend: {
      position: "top",
      labels: {
        colors: '#A0AEC0',
      }
    },
    xaxis: {
      categories: labels,
      labels: {
        rotate: -45,
        style: { colors: '#A0AEC0' }
      },
    },
    yaxis: {
      labels: { style: { colors: '#A0AEC0' } }
    },
    grid: {
      borderColor: "#E5E7EB",
    },
  };

  const chartSeries = [
    {
      name: "Subscriber Users",
      data: paid_users,
    },
    {
      name: "UnSubscriber Users",
      data: free_users,
    },
  ];

  return (
    <div className='col-12'>
      <div className='card h-100'>
        <div className='card-body'>
          <div className='d-flex align-items-center flex-wrap gap-2 justify-content-between'>
            <h6 className='mb-2 fw-bold text-lg mb-0'>Balance Statistic</h6>
          </div>
          <ul className='d-flex flex-wrap align-items-center justify-content-center mt-3 gap-3'>
            <li className='d-flex align-items-center gap-2'>
              <span className='w-12-px h-12-px rounded-circle bg-primary-600' />
              <span className='text-secondary-light text-sm fw-semibold'>
                Subscription:
                <span className='text-primary-light fw-bold'>{paid_users.reduce((a, b) => a + b, 0)}</span>
              </span>
            </li>
            <li className='d-flex align-items-center gap-2'>
              <span className='w-12-px h-12-px rounded-circle bg-yellow' />
              <span className='text-secondary-light text-sm fw-semibold'>
                UnSubscription:
                <span className='text-primary-light fw-bold'>{free_users.reduce((a, b) => a + b, 0)}</span>
              </span>
            </li>
          </ul>
          <div className='mt-40'>
            <div id='balanceStatistics'>
              <ReactApexChart
                options={chartOptions}
                series={chartSeries}
                type='bar'
                height={250}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSubscriptionStatistic;
